import {
  CLEAR_NOTIFICATION,
  MUTE_AUDIO,
  AUDIO_NOTIFICATION,
  OPEN_INACTIVITY_ALERT,
  CLOSE_INACTIVITY_ALERT,
  TOGGLE_CONFIRMATION,
  SET_TEMPLATE_TRAY_IS_OPEN,
  OPEN_DASHBOARD_VIEW,
  SET_RIGHT_SIDEBAR_TAB,
  SET_LEFT_BAR_BLUE_DOT,
  OPEN_MEDIA_MODAL,
  CLOSE_MEDIA_MODAL,
  UPDATE_MEDIA_MODAL,
  REQUEST_GET_JOBS_ERROR,
} from '../constants/actions';
import { selectVisibleActiveChatMedia } from '@app/components/Media/MediaModal/media-modal-helpers';

export const openDashboardView = (view) => ({
  type: OPEN_DASHBOARD_VIEW,
  payload: view,
});

export const setRightSidebarTab = (view) => ({
  type: SET_RIGHT_SIDEBAR_TAB,
  payload: view,
});

export const setTemplateTrayIsOpen = (boolean, context) => ({
  type: SET_TEMPLATE_TRAY_IS_OPEN,
  payload: {
    boolean,
    ...(context && { context }),
  },
});

export const closeForm = (type) => ({
  type: `CLOSE_${type.reducerCase()}_FORM`,
});

export const clearFilter = (id) => ({ type: 'CLEAR_FILTER', payload: id });
export const clearNotification = () => ({ type: CLEAR_NOTIFICATION });
export const audioNotification = () => ({ type: AUDIO_NOTIFICATION });
export const openInactivityAlert = () => ({ type: OPEN_INACTIVITY_ALERT });

export const closeInactivityAlert = (shouldLogout) => ({
  type: CLOSE_INACTIVITY_ALERT,
  payload: { shouldLogout },
});

export const muteAudio = (mute) => (dispatch) => {
  localStorage.setItem('muted', mute);
  dispatch({ type: MUTE_AUDIO, payload: mute });
};

export const toggleConfirmation = (payload) => ({
  type: TOGGLE_CONFIRMATION,
  payload,
});

export const sortItems = (type, column, order) => ({
  type: 'SORT_ITEMS',
  payload: { type, column, order },
});

export const openMediaModal = (fileUrl) => (dispatch, getState) => {
  // Compute the index against the SAME visible list the modal renders
  // (selectVisibleActiveChatMedia), so the stored index can't drift from what
  // the lightbox shows — e.g. when an in-session-redacted image (flagged only
  // in the `media` slice) precedes the clicked one.
  const media = selectVisibleActiveChatMedia(getState());
  if (!media?.length) {
    return;
  }
  const mediaIndex = media.findIndex(
    (mediaItem) => mediaItem.fileUrl === fileUrl,
  );
  if (mediaIndex < 0) {
    console.warn('cant find file url at', fileUrl);
    return;
  }
  dispatch({
    type: OPEN_MEDIA_MODAL,
    payload: {
      mediaIndex,
    },
  });
};

export const updateMediaModalIndex = (mediaIndex) => (dispatch) => {
  dispatch({
    type: UPDATE_MEDIA_MODAL,
    payload: {
      mediaIndex,
    },
  });
};

export const closeMediaModal = () => (dispatch) => {
  dispatch({
    type: CLOSE_MEDIA_MODAL,
  });
};

export const unsetLeftBarBlueDot = (target) => ({
  type: SET_LEFT_BAR_BLUE_DOT,
  payload: {
    set: false,
    target,
  },
});

export const setGetJobsApiError = (isError) => (dispatch) => {
  dispatch({
    type: REQUEST_GET_JOBS_ERROR,
    payload: {
      isError,
    },
  });
};
